var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9997 33.6667C7.79468 33.6667 0.333008 26.205 0.333008 17C0.333008 7.79504 7.79468 0.333374 16.9997 0.333374C26.2047 0.333374 33.6663 7.79504 33.6663 17C33.6663 26.205 26.2047 33.6667 16.9997 33.6667ZM16.9997 30.3334C20.5359 30.3334 23.9273 28.9286 26.4278 26.4281C28.9283 23.9276 30.333 20.5363 30.333 17C30.333 13.4638 28.9283 10.0724 26.4278 7.57195C23.9273 5.07147 20.5359 3.66671 16.9997 3.66671C13.4635 3.66671 10.0721 5.07147 7.57158 7.57195C5.0711 10.0724 3.66634 13.4638 3.66634 17C3.66634 20.5363 5.0711 23.9276 7.57158 26.4281C10.0721 28.9286 13.4635 30.3334 16.9997 30.3334ZM16.9997 14.6434L21.713 9.92837L24.0713 12.2867L19.3563 17L24.0713 21.7134L21.713 24.0717L16.9997 19.3567L12.2863 24.0717L9.92801 21.7134L14.643 17L9.92801 12.2867L12.2863 9.92837L16.9997 14.6434Z",
    fill: "#008662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/Close-Circle.fce5e919a3928feb44f7f58a05bf0791.svg";
export { ForwardRef as ReactComponent };